import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { WhoItsForSection } from '../components/WhoItsForSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-brand-cream selection:bg-brand-gold/30 selection:text-brand-navy" data-id="element-143">
      <HeroSection data-id="element-144" />
      <WhatYouGetSection data-id="element-145" />
      <WhoItsForSection data-id="element-146" />
      <HowItWorksSection data-id="element-147" />
      <ProofSection data-id="element-148" />
      <FAQSection data-id="element-149" />
      <OfferSection data-id="element-150" />

      <Footer data-id="element-151" />
    </main>;
}